// src/utils/notificationRouting.js

const normalizeId = (value) => (typeof value === 'string' ? value.trim() : '');

export const buildRecordCommentUrl = ({ recordId, commentId, threadRootId }) => {
  const safeRecordId = normalizeId(recordId);
  const safeCommentId = normalizeId(commentId);
  const safeThreadRootId = normalizeId(threadRootId);

  if (!safeRecordId || !safeCommentId || !safeThreadRootId) {
    return null;
  }

  const params = new URLSearchParams({
    comments: '1',
    threadRootId: safeThreadRootId,
    commentId: safeCommentId
  });

  return `/record/${safeRecordId}?${params.toString()}`;
};

export const getNotificationNavigation = (notification) => {
  if (!notification) {
    return null;
  }

  const explicitUrl =
    typeof notification.url === 'string' ? notification.url.trim() : '';
  if (explicitUrl) {
    return { url: explicitUrl };
  }

  if (notification.type === 'group_message' && notification.groupId) {
    return { url: `/groups/${notification.groupId}` };
  }

  const relatedId = notification.relatedId;
  if (!relatedId) {
    return null;
  }

  const type = notification.type;
  const isRecordNotification = typeof type === 'string' && type.startsWith('record_');

  if (isRecordNotification) {
    if (type === 'record_comment' || type === 'record_reply') {
      const rawCommentId = normalizeId(notification.commentId);
      const rawThreadRootId = normalizeId(notification.threadRootId);
      const commentId = rawCommentId || rawThreadRootId;
      const threadRootId = rawThreadRootId || rawCommentId;
      const recordCommentUrl = buildRecordCommentUrl({
        recordId: relatedId,
        commentId,
        threadRootId
      });
      if (recordCommentUrl) {
        return { url: recordCommentUrl };
      }
    }

    return { url: `/record/${relatedId}` };
  }

  const navigationState = {
    commentIndex:
      notification.commentIndex != null ? parseInt(notification.commentIndex, 10) : null,
    replyIndex:
      notification.replyIndex != null ? parseInt(notification.replyIndex, 10) : null
  };

  const hasStateValues =
    navigationState.commentIndex != null || navigationState.replyIndex != null;

  return {
    url: `/post/${relatedId}`,
    state: hasStateValues ? navigationState : undefined
  };
};
